export const PROJECT_LIMIT= 20;
export const SCENE_LIMIT= 20;
export const GROUP_TAB_TYPE = "groups";
export const USER_TAB_TYPE = "users";
export const DEFAULT_HOTSPOT_ACTION = {
        title: null,
        description: null,
        inventory: null
}